var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg033SgModeOptimization = function Svg033SgModeOptimization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.977 296v-80c0-22.091 17.909-40 40-40h-60c-22.091 0-40 17.909-40 40v80c0 22.091 17.909 40 40 40h60c-22.091 0-40-17.909-40-40z",
    fill: "#a0eda2",
    "data-original": "#cee1f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.977 336h-80c-22.091 0-40-17.909-40-40v-80c0-22.091 17.909-40 40-40h80c22.091 0 40 17.909 40 40v80c0 22.091-17.908 40-40 40zm-40-160v40M110.904 323.088c4.814 10.452 10.649 20.548 17.849 29.588 10.93 14.75 11.602 38.192-2.175 55.672v0c-13.474 17.268-43.564 16.383-61.477-7.213-10.686-13.619-19.526-28.687-26.782-44.414-12.471-26.938.852-53.975 22.41-57.743 21.925-3.943 42.311 7.591 50.175 24.11zm17.849-163.764c-7.2 9.04-13.035 19.136-17.849 29.588-7.864 16.519-28.25 28.053-50.176 24.11-21.558-3.768-34.88-30.805-22.41-57.743 7.256-15.726 16.096-30.794 26.782-44.414 17.913-23.596 48.003-24.482 61.477-7.213v0c13.778 17.48 13.106 40.922 2.176 55.672zm144.468-58.24c-11.413-1.327-23.165-1.551-34.624-.025-18.33 1.555-38.648-9.966-46.458-30.652v0c-7.878-20.6 8.529-45.968 38.003-48.9 17.158-2.128 34.579-1.906 51.785.052 29.512 3.148 45.788 28.553 37.854 49.025h-.002c-7.926 20.743-28.323 32.212-46.558 30.5zm0 309.832c-11.413 1.327-23.165 1.551-34.624.025-18.33-1.555-38.648 9.966-46.458 30.652v0c-7.878 20.6 8.529 45.968 38.003 48.9 17.158 2.128 34.579 1.906 51.785-.052 29.512-3.148 45.788-28.553 37.854-49.025h-.002c-7.926-20.743-28.323-32.212-46.558-30.5zm127.875-87.828c-4.814 10.452-10.649 20.548-17.849 29.588-10.93 14.75-11.602 38.192 2.175 55.672v0c13.474 17.268 43.564 16.383 61.477-7.213 10.686-13.619 19.526-28.687 26.782-44.414 12.471-26.938-.852-53.975-22.41-57.743-21.925-3.943-42.311 7.591-50.175 24.11z",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.247 159.324c7.2 9.04 13.035 19.136 17.849 29.588 7.864 16.519 28.25 28.053 50.176 24.11 21.558-3.768 34.88-30.805 22.41-57.743-7.256-15.726-16.096-30.794-26.782-44.414-17.913-23.596-48.003-24.482-61.477-7.213v0c-13.778 17.48-13.106 40.922-2.176 55.672z",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#14d64d",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#ff5cf4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.612 299.004A200.75 200.75 0 0 1 55.977 256c0-14.763 1.599-29.152 4.635-43.004M126.5 103.562c19.119-16.255 41.335-24.977 65.638-33.157M385.48 408.416c-19.119 16.261-41.336 24.988-65.643 33.172m-127.699.007c-24.303-8.18-46.519-16.902-65.638-33.157",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }));
};

export default Svg033SgModeOptimization;